import React from 'react';
import { useSelector } from 'react-redux';
import { Images, noteStatusEnums } from 'utils';

export const RenderRequirementsModal = ({ handleClose }) => {
    const { item } = useSelector((state) => ({
        item: state.appointment.appointmentById,
    }));
    const missingClientSignature = item?.requireSignature && !item?.signature?.key;
    const missingProviderSignature = item?.requireProviderSignature && !item?.providerSignature?.key;
    const missingNote = item?.requireNote && item?.noteCounts?.session?.completed === 0;

    const allChecks = [
        {
            key: 'note',
            required: !!item?.requireNote,
            missing: missingNote,
            title: 'At least one submitted session note is required',
            description: 'Submit a session note before rendering.',
        },
        {
            key: 'clientSignature',
            required: !!item?.requireSignature,
            missing: missingClientSignature,
            title: 'Client / Guardian signature is required',
            description: 'Complete in Signatures section.',
        },
        {
            key: 'providerSignature',
            required: !!item?.requireProviderSignature,
            missing: missingProviderSignature,
            title: 'Provider signature is required',
            description: 'Provider must sign to proceed.',
        },
    ].filter((c) => c.required);

    const requiredItems = allChecks.filter((c) => c.missing);
    const completedItems = allChecks.filter((c) => !c.missing);

    return (
        <div className="render-req-modal">
            <div className="render-req-modal-header">
                <div className='render-req-modal-warning-icon'>
                   <img src={Images.alertWarning} alt="warning" />
                </div>
                <div>
                    <p className="render-req-modal-title">Unable to Render Appointment</p>
                    <p className="render-req-modal-subtitle">Complete the required items below.</p>
                </div>
            </div>

            {requiredItems.length > 0 && (
                <div className="render-req-modal-section">
                    <p className="render-req-modal-section-label">
                        Required ({requiredItems.length})
                    </p>
                    {requiredItems.map((check) => (
                        <div key={check.key} className="render-req-modal-item">
                            <span className="render-req-dot orange" />
                            <div>
                                <p className="render-req-item-title">{check.title}</p>
                                <p className="render-req-item-desc">{check.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {completedItems.length > 0 && (
                <div className="render-req-modal-section">
                    <p className="render-req-modal-section-label">
                        Completed ({completedItems.length})
                    </p>
                    {completedItems.map((check) => (
                        <div key={check.key} className="render-req-modal-item completed">
                            <img src={Images.checkedMarkGreen} alt="checkedMarkGreen" />
                            <div>
                                <p className="render-req-complete-item-title">{check.title}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <button className="render-req-modal-ok-btn" onClick={handleClose}>
                OK
            </button>
        </div>
    );
};
